<template>
  <div
    class="componentBox"
    :id="'swiperBox' + myid.container_id + myid.rect_id + indexVal"
    @click.stop
  >
    <div v-if="(pageContent.type=='img' || isThumbsSwiper)" class="img" :style="getImgStyle" @click="clickEv()"></div>
    <div class="video-box video-component-wrap" v-if="(pageContent.type=='video' && !isThumbsSwiper)">
      <!-- <video :id="'myVideo' + Object.values(myid).join('')" class="video-js vjs-default-skin vjs-big-play-centered">
        <source :src="videoSrc" type="video/ogg"/>
      </video> -->
      <video class="video-js"  poster="../../../assets/images/blank.png" :id="'myVideo' + Object.values(myid).join('') + indexVal" autoplay="true" muted="true" :loop="loopPlay" :src="videoSrc" :class="'myVideo' + Object.values(myid).join('') + indexVal">
      </video>
    </div>
  </div>
</template>

<script>
import $ from "jquery"
import { Loading } from "element-ui"
import { _throttle } from "utils"
import componentsMixin from "./componentsMixin"
import { _debounce } from "utils"
import Video from "video.js"
export default {
  name: "swiper-layoutComponent-bg",
  mixins: [componentsMixin],
  props: {
    pageContent: {
      type: Object
    },
    showBigImg: {
      type: [Boolean, undefined]
    },
    myid: {
      type: Object
    },
    isThumbsSwiper: {
      type: [Boolean],
      default: false
    },
    indexVal: {
      type: [Number],
    }
  },
  data() {
    return {
      loadInstance: null,
      dialogPlayStatus: false,
    }
  },
  mounted() {
    // 隐藏控制条
    setTimeout(() => {
      const vedioId = "#video" + Object.values(this.myid).join("")
      const vcontrol = document.querySelector(vedioId + " .vjs-control-bar")
      if(vcontrol) vcontrol.style.display = "none"
    },500)
  },
  beforeDestroy() {
    if (this.myPlayer) {
      this.myPlayer.dispose()
    }
  },
  watch: {
    pageContent: {
      deep: true,
      handler(o, n) {
        console.log('n:>>',n,o);
        if (!o) return
        if(o.type === 'video') {
          this.videoSrc = o.objectId
        }
      }
    },
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    videoSrc: {
      get() {
        return this.getVideoSrc(this.pageContent.objectId)
      },
      set(val) {
        return this.getVideoSrc(val)
      }
    },
    loopPlay() {
      return this.pageContent.loopPlay
    },
    getImgStyle() {
      return {
        "background-image": "url(" + this.pageContent.imgUrl + ")",
        "background-repeat": this.pageContent.repeatType ? this.pageContent.repeatType : 'no-repeat',
        "background-size": this.pageContent.clipSize ?  this.pageContent.clipSize : 'cover',
        "background-position": this.pageContent.alignType ? this.pageContent.alignType : 'center center',
      }
    },
  },
  methods: {
    clickEv(e) {
      console.log('e :>>',e);
      if (!this.showBigImg) return
      this.loadInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.8)",
        spinner: "swiper_big_img"
      })
      const self = this
      requestAnimationFrame(() => {
        const body = window.getComputedStyle(document.body)
        const bodyW = Number(body.getPropertyValue("width").slice(0, -2))
        const bodyH = Number(body.getPropertyValue("height").slice(0, -2))
        const maskEl = document.querySelector(".el-loading-mask")
        const imgEl = document.createElement("div")
        maskEl.style.display = "flex"
        maskEl.style.alignItems = "center"
        maskEl.style.justifyContent = "center"
        imgEl.setAttribute("class", "swiper_big_img")
        imgEl.style.backgroundImage = `url("${this.pageContent.imgSrc}")`
        imgEl.style.width = (this.pageContent.width * 2 > bodyW ? bodyW : this.pageContent.width * 2) + "px"
        imgEl.style.height = (this.pageContent.height * 2 > bodyH ? bodyH : this.pageContent.height * 2) + "px"
        imgEl.style.backgroundRepeat = this.pageContent.repeatType
        imgEl.style.backgroundSize = this.pageContent.clipSize
        imgEl.style.backgroundPosition = this.pageContent.alignType
        maskEl.appendChild(imgEl)
        imgEl.addEventListener("click", this.loadingClose)
      })
    },
    getVideoSrc(objectId) {
      if(objectId){
        let ypDataUrl = '//yp.mh.chaoxing.com/upload/yunpan/' + objectId + '/status';
        this.instance.get(ypDataUrl).then(res => {
          // this.myPlayer.reset() //重置 video
          // this.myPlayer.src([
          //   {
          //     src: res.data.http
          //   }
          // ])
          // this.myPlayer.load()
          // this.initVideoHandle()
          $(".myVideo" + Object.values(this.myid).join("") + this.indexVal).attr("src",res.data.http)
          this.removeOpacity()
          return res.data.http
        })
      }else{
        // 测试地址
        this.removeOpacity()
        return  require("../../../assets/images/default-video1.mp4")
      }
    },
    removeOpacity(){
      setTimeout(()=>{
        /*处理视频未加载回来时的黑屏*/
        const vedioId = "#myVideo" + Object.values(this.myid).join("") + this.indexVal
        $(vedioId).on('loadedmetadata',()=>{
          $(".myVideo" + Object.values(this.myid).join("") + this.indexVal).removeClass("opacity0")
        })
      },500)
    },
    initVideoHandle() {
      this.$nextTick(() => {
        const myVideo = document.getElementById("myVideo" + Object.values(this.myid).join(""))
        if(!myVideo) return
        this.myPlayer = Video("myVideo" + Object.values(this.myid).join(""), {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: true,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          //设置视频播放器的显示宽度（以像素为单位）
          width: "100%",
          //设置视频播放器的显示高度（以像素为单位）
          height: "100%",
          poster: "",
          loop: this.loopPlay,
          muted: true //静音自动播放
        })
        this.videoPauseBtnHandle()
      })
    },
    videoPauseBtnHandle() {
      const vedioId = "#video" + Object.values(this.myid).join("")
      const vb = document.querySelector(vedioId + " .vjs-big-play-button")
      const vbIcon = document.querySelector(vedioId + " .vjs-big-play-button .vjs-icon-placeholder")
      if(!vb) return
      vb.style.width = "40px"
      vb.style.height = "40px"
      vb.style.borderStyle = ""
      vb.style.borderWidth = ""
      vb.style.borderColor = ""
      vb.style.backgroundColor = "rgba(255, 255, 255, 0.7)"
      vb.style.borderRadius = "50%"
      vbIcon.style.color = "#000"
      vbIcon.style.lineHeight = "40px"
    },
    loadingClose(e) {
      this.loadInstance.close()
      e.target.removeEventListener("click", this.loadingClose)
    }
  }
}
</script>
<style>
</style>
<style scoped>
.big_img_preview {
  position: fixed;
  width: 100%;
  height: 100%;
  background: red;
}
.componentBox {
  width: 100%;
  height: 100%;
  position: relative;
}
.componentBox .img {
  width: 100%;
  height: 100%;
}
.ref-line {
  position: absolute;
  background-color: rgb(255, 0, 204);
  z-index: 9999;
}

.v-line {
  width: 1px;
}

.h-line {
  height: 1px;
}

.video-box {
  width: 100%;
  height: 100%;
}
.video-box .video-js {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  object-fit: cover;
}
.video-box .video-js video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
::v-deep .video-js.vjs-paused .vjs-big-play-button {
  display: block;
  margin-top: 0;
  margin-left: 0;
  transform: translate(-50%, -50%);
}
.opacity0{
  opacity: 0;
}
</style>
